import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  signal,
} from '@angular/core';
import { Router } from '@angular/router';
import { NavigationItem } from '../../../interfaces/navigationList.interface';
import { PageContainerService } from '../../../services/page-container.service';
import { tap } from 'rxjs';
import { getLeafItemByRoutePath } from '@core/components/pages-container/utilities-functions';

@Component({
  selector: 'z-mobile-page-title',
  standalone: true,
  imports: [],
  templateUrl: './mobile-page-title.component.html',
  styleUrl: './mobile-page-title.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobilePageTitleComponent {
  readonly #destroyRef = inject(DestroyRef);
  readonly #pageContainerService = inject(PageContainerService);
  readonly #router = inject(Router);
  readonly #activeSectionRoute =
    this.#pageContainerService.activeSectionRoute.pipe(
      tap(_ => {
        const currentRoute = this.#pageContainerService
          .getRoutePath()
          .find(x => x.url === this.#router.url)?.routePath;
        const routes = this.#pageContainerService.getNavigationList();
        if (currentRoute) {
          const leafItem = getLeafItemByRoutePath(routes, currentRoute);
          this.currentPageData.set(leafItem);
        }
      }),
    );

  currentPageData = signal<NavigationItem | null>(null);

  ngOnInit() {
    const activeSectionRouteSubscription = this.#activeSectionRoute.subscribe();
    this.#destroyRef.onDestroy(() => {
      activeSectionRouteSubscription.unsubscribe();
    });
  }
}
